import ThemeToggle from './ThemeToggle';

/** Appearance tab: the discoverable home for the theme preference, alongside
 *  the always-available toggle in the header and drawer. */
export default function AdminAppearanceSettings() {
  return (
    <div className="space-y-6 sm:space-y-8">
      <div className="border-default bg-surface overflow-hidden rounded-xl border shadow-sm">
        <div className="border-subtle border-b px-4 py-4 sm:px-6 sm:py-5">
          <h2 className="text-fg text-base font-bold sm:text-lg">Theme</h2>
          <p className="text-fg-muted mt-0.5 hidden text-xs sm:block sm:text-sm">
            Choose how Calendyz looks on this device.
          </p>
        </div>
        <div className="space-y-3 px-4 py-4 sm:px-6 sm:py-5">
          <ThemeToggle variant="mobile" />
          <p className="text-fg-muted text-xs">
            <span className="text-fg-secondary font-medium">System</span> follows your device's
            appearance setting and switches automatically. This preference is saved per device.
          </p>
        </div>
      </div>
    </div>
  );
}
